import { useMemo } from "react";

import { useCsvExportColumnOptions } from "app/pages/sales-intelligence/modules/enrichment/hooks/useCsvExportColumnOptions";
import { columnsExportService } from "app/pages/sales-intelligence/modules/enrichment/services/columns-export/columnsExportService";
import type { ColumnsConfigType } from "app/pages/sales-intelligence/modules/enrichment/store/type";

type HookValue = {
    config: readonly ColumnsConfigType[];
    isLoading: boolean;
};

export const useContactsColumnConfigs = (): HookValue => {
    const { data: columnsData, isLoading } = useCsvExportColumnOptions();

    const config = useMemo((): readonly ColumnsConfigType[] => {
        if (!columnsData) {
            return [];
        }

        return columnsExportService.buildContactsConfig(columnsData);
    }, [columnsData]);

    return { config, isLoading };
};
